module.exports = __webpack_public_path__ + "img/logo.6764a784.png";